export const Setting = {
	agreementHistories: [],
	agreement : null,
    attachmentConfig: {
        comments: {
		    id: -1,
		    maxAttachmentQuantity: 0,
		    maxAttachmentSize: 0,
		    maxAllAttachmentsSize: 0
        },
        resultsPublish: {
		    id: -1,
		    maxAttachmentQuantity: 0,
		    maxAttachmentSize: 0,
		    maxAllAttachmentsSize: 0
        },
	},
	authorizationSettings: {
		id: -1,
		systemName: '',
		serviceAddress: '',
	},
	commentConfig: null,
    passwordConfig: {
        backoffice: {
		    id: -1,
		    lowerCaseRequired: false,
		    upperCaseRequired: false,
		    digitRequired: false,
		    specialSignRequired: false,
		    passwordDaysValidity: -1,
		    minPasswordLength: -1,
		    failedLoginAttempts: -1,
        },
        frontoffice: {
		    id: -1,
		    lowerCaseRequired: false,
		    upperCaseRequired: false,
		    digitRequired: false,
		    specialSignRequired: false,
		    passwordDaysValidity: -1,
		    minPasswordLength: -1,
		    failedLoginAttempts: -1,
        },
    },
    templates: [],
    template: null,
    thematicArea: null,
	thematicAreas: []
}